import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AllDriverDetails,
  AddDriverDetails,
  UpdateDriverDetails,
  getDriverById,
} from "../../Apis/driverApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import Loader from "../../Common/Loader/loader";
import { useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import { withTranslation } from "react-i18next";
import { AllCollectionTypeDetails } from "../../Apis/collectionTypeApi";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { canWritePermission } from "../../Common/helper/helpar";
import TableSkeleton from "../AllotedMaster/TableSkeleton";
const DriverCreation = ({ t }) => {
  const headers = [
    "driver",
    "mobileNumber",
    "collectionType",
    "employeeId",
    "status",
    "actions",
  ];
  const navigate = useNavigate();
  const [lgShow, setLgShow] = useState(false);
  const [driverDetails, setDriverDetails] = useState([]);
  const [editDriverData, setEditDriverData] = useState("");
  const [driverData, setDriverData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [idProofFile, setIdProofFile] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [collectionTypeDetails, setCollectionTypeDetails] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [searchDriver, setSearchDriver] = useState("");
  const [searchCollectionType, setSearchCollectionType] = useState("");
  const [filterOriginalDriverData, setFilterOriginalDriverData] = useState([]);
  const [canWriteValue, setCanWriteValue] = useState(null);

  useEffect(() => {
    setCanWriteValue(canWritePermission("Drivers"));
  },[] )

  const [formInput, setFormInput] = useState({
    driverName: "",
    mobileNumber: "",
    identityProofImage: null,
    drivingLicenseNumber: "",
    otherDetails: "",
    isActive: true,
    driverCode: "",
    collectionTypeId: "",
  });

  const handleClose = () => {
    setEditDriverData(null);
    setLgShow(false);
    setFormInput({
      driverName: "",
      mobileNumber: "",
      identityProofImage: "",
      drivingLicenseNumber: "",
      otherDetails: "",
      isActive: "",
      driverCode: "",
      collectionTypeId: "",
    });
    setIdProofFile(null);
    setFormSubmitted(false);
  };

  const handleShow = () => {
    setLgShow(true);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      id: "",
      driverName: "",
      mobileNumber: "",
      identityProofImage: "",
      otherDetails: "",
      drivingLicenseNumber: "",
      isActive: true,
      driverCode: "",
      collectionTypeId: "",
    });
    setIdProofFile(null);
  };

  const handleEditDriverData = (selectedDriver) => {
    setEditDriverData(selectedDriver);
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    setFormInput({
      driverId: selectedDriver.driverId,
      driverName: selectedDriver.driverName,
      mobileNumber: selectedDriver.mobileNumber,
      identityProofImage: selectedDriver.identityProofImage || null,
      // "https://stimagegvp.blob.core.windows.net/swmp2images/3_Ramky_Re_Logo_Master.png",
      drivingLicenseNumber: selectedDriver.drivingLicenseNumber,
      otherDetails: selectedDriver.otherDetails,
      isActive: selectedDriver.isActive,
      driverCode: selectedDriver.driverCode,
      collectionTypeId: selectedDriver.collectionTypeId,
    });
    setLgShow(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = "";

    switch (name) {
      case "driverName":
        sanitizedValue = value
            .slice(0, 100) // Limit to 100 characters
            .replace(/[^A-Za-z\s]/g, "") // Allow only alphabets and spaces
            .replace(/^\s+/, "") // Remove leading spaces
            .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space
        break;
    
        // .toUpperCase();
        break;
      case "driverCode":
        // Allow only alphanumeric characters and hyphens for the driver code
        sanitizedValue = value.toUpperCase().replace(/[^A-Z0-9-]/g, "");
        break;
        case "mobileNumber":
          sanitizedValue = value.replace(/\D/g, ""); // Remove non-numeric characters
          if (/^[0-5]/.test(sanitizedValue)) {
              sanitizedValue = ""; // Clear value if it starts with 0,1,2,3,4,5
          } else {
              sanitizedValue = sanitizedValue.slice(0, 10); // Limit to 10 digits
          }
          break;
      
      case "drivingLicenseNumber":
        sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 16);
        break;
      case "collectionTypeId":
        // Check if the value is a radio button selection
        const intValue = parseInt(value, 10);

        // If it's a radio button, set the value directly
        setFormInput((prevData) => ({
          ...prevData,
          [name]: intValue,
        }));

        // Also set the collectionTypeName based on the selected collectionTypeId
        const selectedCollectionType = collectionTypeDetails.find(
          (type) => type.collectionTypeId === intValue
        );

        setFormInput((prevData) => ({
          ...prevData,
          collectionTypeName: selectedCollectionType
            ? selectedCollectionType.collectionTypeName
            : "",
        }));
        return; // Exit the switch statement early after handling radio button

      case "otherDetails":
        sanitizedValue = value
            .slice(0, 255) // Limit to 255 characters
            .replace(/^\s+/, "") // Remove leading spaces
            .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space
        break;
        break;
      default:
        sanitizedValue = value;
    }

    setFormInput((prevData) => ({
      ...prevData,
      [name]: sanitizedValue,
    }));
  };

  const handleCreateOrUpdateDriverDetails = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    //   const firstDigit = formInput.mobileNumber.charAt(0);
    // if (!["6", "7", "8", "9"].includes(firstDigit)) {
    //   toast.error("Mobile number should start with 6, 7, 8, or 9", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //   });
    //   return; // Prevent form submission
    // }
    try {
      setIsLoading(true);
      const {
        driverName,
        driverCode,
        mobileNumber,
        drivingLicenseNumber,
      } = formInput;
      if (editDriverData) {
        // Perform validation for required fields only when adding new data
        if (
          !formInput.driverName ||
          !formInput.mobileNumber ||
          !formInput.driverCode ||
          !formInput.drivingLicenseNumber
        ) {
          // toast.error("Please fill in all required fields.", {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          // });
          return;
        }
      }
      const isDuplicateCode = driverDetails.some(
        (driver) =>
          driver.driverCode === formInput.driverCode &&
          (!editDriverData || driver.id !== editDriverData.id)
      );

      if (isDuplicateCode) {
        toast.error(
          "Employee Id already exists. Please choose a different one.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          }
        );
        return;
      }

      const formData = new FormData();
      formData.append("driverName", formInput.driverName);
      formData.append("mobileNumber", formInput.mobileNumber);
      formData.append("drivingLicenseNumber", formInput.drivingLicenseNumber);
      formData.append("otherDetails", formInput.otherDetails);
      formData.append("isActive", formInput.isActive);
      formData.append("driverCode", formInput.driverCode);
      formData.append("collectionTypeId", formInput.collectionTypeId);
      formData.append("collectionTypeName", formInput.collectionTypeName);

      if (formInput.identityProofImage) {
        formData.append("identityProofImage", formInput.identityProofImage);
      }


      if (editDriverData) {
        formData.append("driverId", editDriverData.id);
        const updatedDriverData = { ...formInput };
        const response = await UpdateDriverDetails(updatedDriverData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        setDriverDetails((prevDetails) =>
          prevDetails.map((driver) =>
            driver.id === response.id ? response : driver
          )
        );

        toast.success("Driver Details Updated Successfully");
        fetchDriverDetails();
        handleClose();
      } else {

        const response = await AddDriverDetails(formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        setDriverDetails([...driverDetails, response]);
        toast.success("New Driver added successfully");
      }
      fetchDriverDetails();
      handleClose();
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 404) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        // Handle network errors or other unexpected errors
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];


    const compressedFile = await compressImage(file);
    // Set the file name in the state

    setFormInput((prevData) => ({
      ...prevData,
      identityProofImage: compressedFile || prevData.identityProofImage,
    }));

    setIdProofFile(compressedFile);
  };

  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.1,
      maxWidthOrHeight: 800,
    };
    try {
      const compressedFile = await imageCompression(file, options);

      // Create a new File object with the compressed image data
      const compressedImageFile = new File([compressedFile], file.name, {
        type: compressedFile.type,
      });
      return compressedImageFile;
    } catch (error) {
      console.error("Error compressing image:", error);
      return file;
    }
  };





  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await AllDriverDetails();
      setDriverDetails(response);
      setOriginalData(response)
    } catch (error) {
      console.error("Error fetching driver data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const collectionTypeData = async () => {
    try {
      setIsLoading(true);
      const response = await AllCollectionTypeDetails();
      setCollectionTypeDetails(response);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(
    () => {
      collectionTypeData();
    },
    []
    // [lgShow]
  );

  useEffect(() => {
    fetchData();
  }, []);

  const handleViewDriverData = async (id) => {
    setIsLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const response = await getDriverById(id);
      const driverDetails = response.data.data;
      navigate("/driver-details", { state: { driverDetails } });
    } catch (error) {
      //console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDriverDetails = async () => {
    setIsLoading(true);
    const [driverData] = await Promise.all([AllDriverDetails()]);
    const driverName = driverData.map((station) => {
      return {
        ...station,
        driver: station.driverName, // Assuming the API response has a key named shiftName for shift names
        collectionType: station.collectionTypeName.toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" "),
        employeeId: station.driverCode,
        status: station.isActive ? "Active" : "InActive",
      };
    });
    // setDriverData(driverName);


    // Sort the data based on the isActive field
    const sortedDriverData = driverName.sort((a, b) => {
      if (a.isActive === b.isActive) {
        return 0;
      }
      return a.isActive ? -1 : 1;
    });
    setFilterOriginalDriverData(sortedDriverData);
    setDriverData(sortedDriverData);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchDriverDetails();
  }, []);

  // const downloadAsExcel = () => {
  //   const ws = XLSX.utils.json_to_sheet(driverData); // Convert table data to worksheet
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "driver_details"); // Append worksheet to workbook
  //   XLSX.writeFile(wb, "driver_details.xlsx"); // Trigger file download with specified filename
  // };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = filteredRows.length > 0 ? filteredRows : originalData;

    // Sort data to have active records at the top
    const sortedDataForExport = [...dataToUse].sort((a, b) => {
      // Place 'Active' records before 'Inactive'
      return a.isActive === b.isActive ? 0 : a.isActive ? -1 : 1;
    });
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Driver Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Drivers");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 6); // Merge cells for downloadDateTime from column 2 to 6
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add "Driver Details" header
    worksheet.addRow(["", "", "Driver Details", ""]);
    worksheet.mergeCells(2, 2, 2, 6); // Merge cells for Driver Details from column 2 to 6
    worksheet.getCell(2, 2).value = "Driver Details";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add an empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Driver",
      "Mobile Number",
      "Collection Type",  // Changed from 'Driver License Number' to 'Collection Type'
      "Employee Id",
      "Status",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Align text to the left
      if (colNumber >= 1 && colNumber <= 6) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Background color for header
          bgColor: { argb: "FFFFFFFF" }, // White text color
        };
      }
    });

    // Add data rows
    sortedDataForExport.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.driverName,
          item.mobileNumber,
          item.collectionTypeName,   // Use 'collectionType' instead of 'drivingLicenseNumber'
          item.driverCode,
          item.isActive ? 'Active' : 'InActive',  // Show 'Active' or 'Inactive' based on status
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 6) {
            // Align the columns from 1 to 6 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },    // S.No
      { width: 20 },   // Driver Name
      { width: 20 },   // Mobile Number
      { width: 20 },   // Collection Type
      { width: 20 },   // Employee Id
      { width: 15 },   // Status
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SCVDriverDetails.xlsx"; // Filename for the Excel download
    a.click();
    URL.revokeObjectURL(url);  // Revoke the URL after download
  };


  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...driverData].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };
  const filteredRows = driverData?.filter(item => {
    return (
      (!searchCollectionType || item?.collectionTypeId?.toString() === searchCollectionType) &&
      (!searchDriver ||
        (item?.driver?.toLowerCase()?.includes(searchDriver.toLowerCase()) ||
          item?.mobileNumber?.toLowerCase()?.includes(searchDriver.toLowerCase()) ||
          item?.driverCode?.toLowerCase()?.includes(searchDriver.toLowerCase()))
      )
    );
  });
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">Driver Details</h4>
            <div className="row mt-3  align-items-center">
              <div className="col-md-8">
                <div className="row align-items-center">
                  <div className="col-md-4">
                    <input
                      placeholder="Search Driver and Mobile No."
                      type="text"
                      className="form-control bg-white"
                      value={searchDriver}
                      onChange={(e) => setSearchDriver(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <div className="form-group-filter">
                      <select
                        className="form-select bg-white"
                        value={searchCollectionType}
                        onChange={(e) => setSearchCollectionType(e.target.value)}
                      >
                        <option value="">Collection Type</option>
                        <option value={1}>Primary Collection</option>
                        <option value={2}>Secondary Collection</option>
                        <option value={3}>Tertiary Collection</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex justify-content-end">
                  {canWriteValue === true ?
                    <button className="button-container ms-auto" onClick={handleShow}>
                      <i className="fa-solid fa-plus me-1 icon-container"></i>
                      {t("addDriver")}
                    </button>
                    : ''}
                  <button className="btn btn-excel" onClick={handleSortAndExport}>
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>
                </div>
              </div>
            </div>


            <div className="card mt-3">
              <div className="card-body">
                {
                  isLoading?<TableSkeleton/>:
                <TableComponent
                  DataFetchURL={filteredRows}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 0
                    )
                  }
                  viewData={(id) => handleViewDriverData(id)}
                  editData={handleEditDriverData}
                  onSort={handleSort}
                />}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => handleClose()}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={{ fontSize: "20px" }}>
          <Modal.Title>
            {" "}
            {editDriverData ? t("Edit Driver") : t("Add Driver")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateOrUpdateDriverDetails}>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("employeeID")}{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="driverCode"
                    className={`form-control ${formInput.driverCode || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    placeholder="Enter Employee Id"
                    onChange={handleInputChange}
                    value={formInput.driverCode}
                    maxLength={8}
                    disabled={!canWriteValue}
                  />
                  {!formInput.driverCode && formSubmitted && (
                    <div className="required-message small">
                      {" "}
                      Employee Id is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("driverName")}{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    name="driverName"
                    placeholder="Enter Driver Name"
                    className={`form-control ${formInput.driverName || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    onChange={handleInputChange}
                    value={formInput.driverName}
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.driverName && formSubmitted && (
                    <div className="required-message small">
                      Driver Name is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("mobile")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    //type="number"
                    name="mobileNumber"
                    placeholder="Enter Mobile Number"
                    className={`form-control ${(!formInput.mobileNumber && formSubmitted) ||
                      (formInput.mobileNumber &&
                        formInput.mobileNumber.toString().length !== 10 &&
                        formSubmitted)
                      ? "input-error"
                      : ""
                      }`}
                    onChange={handleInputChange}
                    value={formInput.mobileNumber}
                    maxLength={10}
                    disabled={!canWriteValue}
                  />
                  {/* Display error message if mobile number is less than 10 digits */}
                  {(!formInput.mobileNumber && formSubmitted) ||
                    (formInput.mobileNumber &&
                      formInput.mobileNumber.toString().length !== 10 &&
                      formSubmitted) ? (
                    <div className="required-message small">
                      {!formInput.mobileNumber
                        ? "Mobile Number is Required"
                        : "Mobile number must be 10 digits"}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("Collection Type Name")}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    name="collectionTypeId"
                    className={`form-select ${formInput.collectionTypeId || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    onChange={handleInputChange}
                    value={formInput.collectionTypeId} // Set value from formInput state
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {/* Map through collection types and render options */}
                    {collectionTypeDetails.map((type) => (
                      <option
                        key={type.collectionTypeId}
                        value={type.collectionTypeId} // Make sure this value matches the collectionTypeId
                      >
                        {type.collectionTypeName}
                      </option>
                    ))}
                  </select>
                  {!formInput.collectionTypeId && formSubmitted && (
                    <div className="required-message small">
                      CollectionType Name is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    {t("license")} <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Driver License Number"
                    name="drivingLicenseNumber"
                    className={`form-control ${formInput.drivingLicenseNumber || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    onChange={handleInputChange}
                    value={formInput.drivingLicenseNumber}
                    disabled={!canWriteValue}
                  />
                  {formSubmitted && (
                    !formInput.drivingLicenseNumber ? (
                      <div className="required-message small">
                        Driver License Number is Required
                      </div>
                    ) : (
                      formInput.drivingLicenseNumber.length !== 16 && (
                        <div className="required-message small">
                          License number must be 16 digits
                        </div>
                      )
                    )
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">{t("idProof")}</label>
                  <div>
                    <input
                      type="file"
                      name="identityProofImage"
                      className="form-control"
                      onChange={handleFileChange}
                      accept=".png, .jpg, .jpeg" // Specify accepted file formats
                      disabled={!canWriteValue}
                    />

                    {idProofFile && (
                      <div style={{ marginTop: "10px" }}>
                        <img
                          src={URL.createObjectURL(idProofFile)}
                          alt="ID Proof"
                          style={{ maxWidth: "100%", maxHeight: "150px" }}
                        />
                      </div>
                    )}
                    {!idProofFile && editDriverData && (
                      editDriverData.idProofImageUrl ? (
                        <img
                          style={{ width: "100%", marginTop: "20px" }}
                          src={editDriverData.idProofImageUrl}
                          alt="ID Proof"
                        />
                      ) : (
                        <p style={{ marginTop: "20px", textAlign: "center", color: "gray" }}>
                          No Image Available
                        </p>
                      )
                    )}

                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">{t("Other Details")}</label>
                  <input
                    type="text"
                    name="otherDetails"
                    className="form-control"
                    placeholder="Enter Other Details"
                    maxLength={200}
                    onChange={handleInputChange}
                    value={formInput.otherDetails}
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
            <div className="col-md-4 form-group" style={{ marginTop: "5px" }}>
              <label className="form-label">
                {t("status")}
                <span style={{ color: "#EC1117" }}> *</span>
              </label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="activeRadio"
                    checked={
                      formInput.isActive === true ||
                      formInput.isActive === "true"
                    } // Check if isActive is true
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: true }, // Set value to true
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="inactiveRadio"
                    checked={
                      formInput.isActive === false ||
                      formInput.isActive === "false"
                    } // Check if isActive is false
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: false }, // Set value to false
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
            </div>
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {editDriverData ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(DriverCreation);
